const API_MENU_ES = 'http://admin.tantaperu.com/wp-json/wp-api-menus/v2/menu-locations/primary/';
const API_MENU_EN = 'http://en.admin.tantaperu.com/wp-json/wp-api-menus/v2/menu-locations/primary/';
const API_HOME_ES = 'http://admin.tantaperu.com/wp-json/acf/v2/options/';
const API_HOME_EN = 'http://en.admin.tantaperu.com/wp-json/acf/v2/options/';

export {
  API_MENU_ES,
  API_MENU_EN,
  API_HOME_ES,
  API_HOME_EN,
};